(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/message/buttons.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/message/buttons.js'); "use strict";


(function (svs, $, gsap) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  class DialogButtons extends svs.components.dialog.PubSub {
    constructor(options) {
      super();
      this.log = new svs.core.log.Logger('DialogButtons');
      this.options = options; 

      this.scrollButtonVisible = false;
      this.buttons = [];
      this.focusCount = 0; 

      this.defineTypes();
      this.render();
    }

    defineTypes() {
      if (this.options.type === svs.components.dialog.type.ERROR && this.options.actions.length !== 1) {
        this.log.error('Only 1 action is allowed in an error message.');
      }

      if (this.options.actions) {
        switch (this.options.actions.length) {
          case 1:
            this.options.actions[0].type = svs.components.dialog.button.SECONDARY;
            break;

          case 2:
            this.options.actions[0].type = svs.components.dialog.button.SECONDARY;
            this.options.actions[1].type = svs.components.dialog.button.PRIMARY;
            break;

          default:
            this.log.error('You must define atleast 1 or 2 actions.');
            break;
        }
      }
    }

    addScrollButton() {
      this._scrollButton = document.createElement('button');
      this._scrollButton.className += 'dialog-button dialog-button-primary js-dialog-button-scrollable dialog-button-scrollable';

      this._scrollButton.setAttribute('title', 'Gå till slutet');

      this._scrollButton.innerHTML = svs.ui.icon.partials.icon({
        icon: 'menu-down',
        color: 'fc-white',
        size: 200
      });
      new svs.components.RippleEffect(this._scrollButton, () => {
        this.emit('scrollToEnd');
      });
      this.el.appendChild(this._scrollButton);
    }

    hideScrollButton() {
      if (this.scrollButtonVisible) {
        this.log.debug('Hide Scroll Button');
        gsap.to(this.buttonsEl, {
          duration: 0.2,
          y: 0,
          onComplete: () => {
            if (this.focusCount > 0) {
              this.setFocus();
            }
          }
        });
        gsap.to(this._scrollButton, {
          duration: 0.2,
          y: 100
        });
        this.scrollButtonVisible = false;
      }
    }

    showScrollButton() {
      if (!this.scrollButtonVisible) {
        if (!this._scrollButton) {
          this.addScrollButton();
        }

        this.log.debug('Show Scroll Button');
        gsap.to(this.buttonsEl, {
          duration: 0.2,
          y: 100
        });
        gsap.to(this._scrollButton, {
          duration: 0.2,
          y: 0,
          onComplete: () => {
            if (this.focusCount > 0) {
              this.setFocus();
            }
          }
        });
        this.scrollButtonVisible = true;
      }
    }

    toggleTabIndex() {
      if (this.scrollButtonVisible) {
        this.buttons.forEach(button => {
          button.tabIndex = -1;
        });
        this._scrollButton.tabIndex = 0;
      } else {
        this.buttons.forEach(button => {
          button.tabIndex = 0;
        });

        if (this._scrollButton) {
          this._scrollButton.tabIndex = -1;
        }
      }
    }

    setFocus() {
      document.activeElement && document.activeElement.blur();
      let btn;

      if (!this.scrollButtonVisible) {
        btn = this.buttons[this.buttons.length - 1];
      } else {
        btn = this._scrollButton;
      }

      if (btn) {
        this.toggleTabIndex();
      } 


      this.focusCount++;
    }

    showLoader(e) {
      this.buttons.forEach(button => {
        button.setAttribute('disabled', 'disabled');
      });
      const loader = new svs.components.Loader('.js-dialog-loader');
      const btnWidth = e.target.clientWidth - 24; 

      e.target.innerHTML = '';
      e.target.insertAdjacentHTML('afterbegin', "<div class=\"js-dialog-loader\" style=\"width: ".concat(btnWidth, "px\"></div>"));
      loader.show(200, 'default');
    }

    createButtonContainer() {
      this.el = document.createElement('div');
      this.el.className += 'dialog-button-container';
    }

    createButtonWrapper() {
      this.buttonsEl = document.createElement('div');
      this.buttonsEl.className += 'dialog-buttons js-dialog-buttons';
    }

    createButtons() {
      if (this.options.actions) {
        this.options.actions.forEach(action => {
          const callback = action.callback; 

          const _button = document.createElement('button');

          _button.className += "dialog-button dialog-button-".concat(action.type);
          _button.innerText = action.title; 

          new svs.components.RippleEffect(_button, e => {
            if (_button.clicked) {
              this.log.debug('Prevented double-click');
              return;
            }

            this.log.debug('Clicked a button');
            _button.clicked = true;
            let delayLoader = 0;

            if (action.showLoader) {
              this.showLoader(e);
              delayLoader = 500;
            }

            if (callback) {
              setTimeout(() => {
                this.emit('callback', {
                  e,
                  callback
                });
              }, delayLoader);
            } else {
              this.emit('close');
            }

            setTimeout(() => {
              _button.clicked = false;
            }, 500);
          });
          this.buttonsEl.appendChild(_button);
          this.buttons.push(_button);
        });
      }
    }

    render() {
      this.createButtonContainer();
      this.createButtonWrapper();
      this.el.appendChild(this.buttonsEl);
      this.createButtons();
    }

  }

  svs.components.dialog.Buttons = DialogButtons;
})(svs, $, gsap);
 })(window);